import { SdaComponent } from './sda.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ SdaComponent });
